<template>
  <div @mouseleave="hideShowLowNav">
    <header id="header">
      <img src="../assets/img/logo.png" alt="" class="logo" @click="toHome" />
      <!-- 导航 -->
      <div class="navbar">
        <ul class="web-ul">
          <li
            class="first-nav"
            :class="{
              navlow: index == 4 || index == 7 || index == 8,
              active: selNavInd === index
            }"
            v-for="(item, index) in links"
            :key="'nav' + index"
            @mouseover="showFunLowNav(item, index)"
          >
            <a
              @click="navHandler(item)"
              :style="{ padding: item.newIcon ? '0 50px' : '' }"
            >
              {{ item.name }}</a
            >
            <img
              v-if="item.newIcon"
              src="../assets/img/aiinspection/new@2x.png"
              alt=""
              style="
                width: 37px;
                height: 18px;
                left: 104px;
                top: 28px;
                z-index: 1;
                position: absolute;
              "
            />

            <!-- 附导航 -->
            <transition name="fade">
              <div
                class="hover-nav"
                :class="[
                  item.styStatus && item.styStatus == 1 ? '' : 'hover-stynav'
                ]"
                :style="{
                  height: isShowLowNav - 1 == index ? 'auto' : '0px'
                }"
              >
                <!-- v-if="isShowLowNav - 1 == index" -->
                <div
                  class="nav-pre"
                  :class="[
                    item.styStatus && item.styStatus == 1 ? '' : 'nav-stypre'
                  ]"
                >
                  <img
                    v-if="item.styStatus && item.styStatus == 1"
                    class="nav-bg"
                    src="../assets/img/nav/nav-bg.png"
                    alt=""
                  />
                  <div class="nav-sinf">
                    <div
                      @click.stop="childNav(val)"
                      :class="[
                        item.styStatus && item.styStatus == 1
                          ? 'nav-single'
                          : 'nav-stysingle'
                      ]"
                      v-for="(val, ind) in item.child"
                      :key="ind + 'single'"
                    >
                      {{ val.name }}
                    </div>
                  </div>
                  <div class="nav-hf">
                    <div
                      v-for="(val, ind) in item.cldTp"
                      :key="ind"
                      class="nav-h-father"
                    >
                      <div class="nav-h-child">{{ val.name }}</div>
                      <div
                        v-for="(v, i) in val.child"
                        :key="i"
                        class="nav-h-i"
                        @click.stop="childTypeNav(val, v)"
                      >
                        {{ v.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </li>
        </ul>
      </div>

      <!-- 小屏导航 -->
      <div class="nav-phone">
        <div class="burger">
          <BurgerNav v-on:childByValue="childByValue" :flg="flg"></BurgerNav>
        </div>
        <transition name="fade">
          <div class="nav-phone-list" v-show="isShowNavPhone">
            <ul>
              <router-link
                v-for="(item, i) in links"
                :key="'phone-' + i"
                :to="{ path: item.path }"
                tag="li"
                class="nav-phone-list-li"
              >
                <div class="phoneNavName" @click="hideList(item)">
                  <span>{{ item.name }}</span>
                  <i
                    @click.stop="openPhoneNav(i)"
                    v-if="item.child"
                    :class="
                      showPhoneLower == i
                        ? 'el-icon-arrow-down'
                        : 'el-icon-arrow-right'
                    "
                  ></i>
                </div>

                <div v-if="item.child && showPhoneLower == i">
                  <!-- 产品中心 -->
                  <ul class="phone-lower" v-if="item.siderNavData">
                    <li
                      v-for="(item, index) in item.siderNavData"
                      :key="'c-' + index"
                      class="phone-lower-two"
                      @click.stop=""
                    >
                      <!-- 二级菜单 -->
                      <div class="phone-lower-two-tit">
                        <span>{{ item.name }}</span>
                        <i
                          @click.stop="openPhoneTwoNav(index)"
                          v-if="item.child"
                          :class="
                            showPhoneTwoLower == index
                              ? 'el-icon-arrow-down'
                              : 'el-icon-arrow-right'
                          "
                        ></i>
                      </div>
                      <!-- 三级菜单 -->
                      <ul
                        class="phone-lower-three"
                        v-if="showPhoneTwoLower == index"
                      >
                        <li
                          v-for="(val, ind) in item.child"
                          :key="'d-' + ind"
                          @click.stop="goNavThree(val)"
                        >
                          {{ val.name }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <!-- 其他二级导航 -->
                  <ul class="phone-lower-other" v-else>
                    <li
                      v-for="(item, index) in item.child"
                      :key="'e-' + index"
                      @click.stop="navTwo(item)"
                    >
                      {{ item.name }}
                    </li>
                  </ul>
                </div>
              </router-link>
            </ul>
          </div>
        </transition>
      </div>
    </header>
  </div>
</template>

<script>
import BurgerNav from "./BurgerNav";
import { mapState } from "vuex";

export default {
  name: "HeaderCom",
  data() {
    return {
      screenWidth: "",
      show: -1,
      flg: false,
      isShowNavPhone: false,
      showPhoneLower: false,
      phoneLowerFlg: false,

      showPhoneTwoLower: -1,

      links: [
        { name: "首页", path: "/", index: 0 },
        {
          name: "产品中心",
          path: "/product",
          index: 1,
          styStatus: 1, //样式
          child: [{ name: "", path: "" }],
          cldTp: [
            {
              name: "智慧城管平台",
              child: [
                { name: "城市运行管理服务平台", path: "/product/management" },
                // { name: "城市运行安全监督平台", path: "/product/citySafety" }
              ]
            },
            {
              name: "智慧城管数据系统",
              child: [
                { name: "综合评价系统", path: "/product/comprehensiveEvaluat" },
                { name: "拟态网格（数字孪生）", path: "/product/mimicryGrid" }
              ]
            },
            {
              name: "智慧城管AI产品",
              child: [
                { name: "AI视频分析系统", path: "/aiInspection" },
                { name: "AI问答", path: "/product/aiAnswer" },
                { name: "AR巡检", path: "/product/ARInspection" },
                { name: "极简上报", path: "/product/productCenter" }
              ]
            },
            {
              name: "智慧城管业务",
              child: [
                { name: "指挥协调系统", path: "/product/commandCoord" },
                { name: "综合执法系统", path: "/product/enforcement" },
                { name: "指挥调度系统", path: "/product/commandDispatch" },
                { name: "园林绿化系统", path: "/product/landscaping" },
                // { name: "智慧环卫系统", path: "/product/smartSanitation" },
                { name: "智慧环卫系统", path: "/product/sanitationSystem" },
                { name: "危爆气体检测系统", path: "/product/dangerousGas" }
              ]
            }
            // {
            //   name: "监督决策应用",
            //   child: [
            //     { name: "城市运行安全监督平台", path: "/product/citySafety" },
            //     { name: "指挥协调系统", path: "/product/commandCoord" },
            //     { name: "综合评价", path: "/product/comprehensiveEvaluat" },
            //     { name: "拟态网格", path: "/product/mimicryGrid" }
            //   ]
            // },
            // {
            //   name: "业务系统应用",
            //   child: [
            //     { name: "综合执法系统", path: "/product/enforcement" },
            //     { name: "指挥调度系统", path: "/product/commandDispatch" },
            //     { name: "园林绿化系统", path: "/product/landscaping" },
            //     { name: "智慧环卫系统", path: "/product/smartSanitation" }
            //   ]
            // },
            // {
            //   name: "物联感知应用",
            //   child: [
            //     { name: "公众应用系统", path: "/product/publicApplication" },
            //     { name: "AI视频分析系统", path: "/aiInspection" },
            //     { name: "AR巡检系统", path: "/product/ARInspection" },
            //     { name: "危爆气体检测系统", path: "/product/dangerousGas" }
            //   ]
            // }
          ],
          siderNavData: [
            {
              name: "城市治理平台",
              child: [
                { name: "城市综合管理服务平台", path: "/product/management" }
              ]
            },
            {
              name: "监督决策应用",
              child: [
                { name: "城市运行安全监督平台", path: "/product/citySafety" },
                { name: "指挥协调系统", path: "/product/commandCoord" },
                { name: "综合评价", path: "/product/comprehensiveEvaluat" },
                { name: "拟态网格", path: "/product/mimicryGrid" }
              ]
            },
            {
              name: "业务系统应用",
              child: [
                { name: "综合执法系统", path: "/product/enforcement" },
                { name: "指挥调度系统", path: "/product/commandDispatch" },
                { name: "园林绿化系统", path: "/product/landscaping" },
                { name: "智慧环卫系统", path: "/product/smartSanitation" }
              ]
            },
            {
              name: "物联感知应用",
              child: [
                { name: "公众应用系统", path: "/product/publicApplication" },
                { name: "AI视频分析系统", path: "/aiInspection" },
                { name: "AR巡检系统", path: "/product/ARInspection" },
                { name: "危爆气体检测系统", path: "/product/dangerousGas" }
              ]
            }
          ]
        },
        {
          name: "AI巡检",
          path: "/aiInspection",
          index: 2,
          newIcon: true //图标
        },
        {
          name: "典型案例",
          path: "/typicalCases",
          index: 3
        },
        {
          name: "新闻动态",
          path: "/news",
          index: 4,
          styStatus: 2, //样式
          child: [
            { name: "企业资讯", path: "/news", query: { type: 1 } },
            { name: "行业动态", path: "/news", query: { type: 2 } },
            { name: "视频中心", path: "/news", query: { type: 3 } }
          ]
        },
        { name: "服务支持", path: "/support", index: 5 },
        {
          name: "关于合能",
          path: "/about",
          index: 6,
          styStatus: 2, //样式
          child: [
            {
              name: "企业简介",
              path: "/about",
              query: { scrollIntoView: "plan" }
            },
            {
              name: "发展历程",
              path: "/about",
              query: { scrollIntoView: "process" }
            },
            {
              name: "企业文化",
              path: "/about",
              query: { scrollIntoView: "culture" }
            },
            {
              name: "资质荣誉",
              path: "/about",
              query: { scrollIntoView: "honor" }
            },
            {
              name: "合能风采",
              path: "/about",
              query: { scrollIntoView: "mien" }
            }
          ]
        },
        {
          name: "加入我们",
          // newPage: true, //打开新标签页
          path: "/joins",
          index: 7
        }
      ],
      isShowLowNav: 0 //显示的附导航所在导航下标+1
    };
  },
  components: {
    BurgerNav
  },
  watch: {
    "$store.state.screenWidth": function(val) {
      //监听vuex中屏幕宽度变化
      this.screenWidth = val;
    },
    screenWidth(val) {
      this.closeLow(val);
    },
    $route(to, from) {
      this.links.map((v, i) => {
        if (to.path.indexOf(v.path) > -1) {
          this.$store.commit("changeNav", v.index);
        }
      });
    }
  },
  computed: {
    ...mapState(["selNavInd"])
  },
  mounted() {
    this.links.map((v, i) => {
      if (this.$route.path.indexOf(v.path) > -1) {
        this.$store.commit("changeNav", v.index);
      }
    });
  },
  methods: {
    // 跳转到首页
    toHome() {
      this.$router.push({ path: "/" });
    },
    // hover导航
    showFunLowNav(item, index) {
      if (
        (item.child && item.child.length) ||
        (item.cldTp && item.cldTp.length)
      ) {
        this.isShowLowNav = index + 1;
      } else {
        this.isShowLowNav = 0;
      }
    },
    // 隐藏副导航
    hideShowLowNav() {
      this.isShowLowNav = 0;
    },
    //   点击导航
    navHandler(item) {
      this.$store.commit("changeNav", item.index);
      if (item.newPage) {
        window.open(item.path);
      } else {
        sessionStorage.setItem("id", "");
        this.$router.push({ path: item.path });
      }
    },
    // 点击附导航
    childNav(val) {
      if (val.path) {
        this.$router.push({
          path: val.path,
          query: val.query
        });
      }
    },
    // 点击三级导航
    childTypeNav(val, v) {
      if (v.path) {
        this.$router.push(v.path);
      }
    },

    closeLow(val) {
      if (val > 1200) {
        if (this.isShowNavPhone) {
          this.isShowNavPhone = false;
        }
        if (this.flg) {
          this.flg = false;
        }
      }
    },

    // 移动端一级导航
    hideList(item) {
      this.closePhoneNav(); //关闭移动端导航效果
      this.navHandler(item);
    },
    // 移动端展开一级导航
    openPhoneNav(i) {
      this.showPhoneTwoLower = -1; //移动端二级导航
      if (this.showPhoneLower == i) {
        this.showPhoneLower = false;
      } else {
        this.showPhoneLower = i; //移动端一级导航
      }
    },
    // 展开移动端产品二级导航
    openPhoneTwoNav(i) {
      if (this.showPhoneTwoLower == i) {
        this.showPhoneTwoLower = -1;
      } else {
        this.showPhoneTwoLower = i; //移动端二级导航
      }
    },
    // 点击移动端三级菜单
    goNavThree(item) {
      this.closePhoneNav(); //关闭移动端导航效果
      this.navHandler(item, 1);
    },
    // 点击移动端产品之外其他二级导航
    navTwo(val) {
      this.closePhoneNav(); //关闭移动端导航效果
      if (val.path) {
        this.$router.push({
          path: val.path,
          query: val.query
        });
      }
    },
    // 关闭移动端导航效果
    closePhoneNav() {
      this.isShowNavPhone = false;
      this.flg = false;
      this.showPhoneLower = false;
      this.phoneLowerFlg = false;
    },

    changeFlg(flg) {
      this.flg = flg;
    },

    //响应式导航
    childByValue: function(childValue) {
      if (childValue == true) {
        this.isShowNavPhone = true;
      } else {
        this.isShowNavPhone = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common";
@import "./HeaderCom.less";
</style>



// WEBPACK FOOTER //
// src/components/HeaderCom.vue